import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.dd`
  margin-bottom: 0;
`

/**
 * SpirMon wrapper for News feed advert articles
 */
class SpirMonWrapperWithoutImpression extends Component {
  shouldComponentUpdate () {
    return false
  }

  componentDidMount () {
    const {
      commentTop,
      commentBottom
    } = this.props

    this.spirStart.outerHTML = commentTop
    this.spirEnd.outerHTML = commentBottom
  }

  /**
   * Render
   * @returns {XML} markup
   */
  render () {
    return (
      <Wrapper>
        <span ref={spir => {
          this.spirStart = spir
        }}/>
        { this.props.children }
        <span ref={spir => {
          this.spirEnd = spir
        }}/>
      </Wrapper>
    )
  }
}

SpirMonWrapperWithoutImpression.propTypes = {
  commentBottom: PropTypes.string.isRequired,
  commentTop: PropTypes.string.isRequired
}

export default SpirMonWrapperWithoutImpression
